import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes, SlotsType } from 'vue'


export const querytableColumnDiyProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type QuerytableColumnDiyProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnDiyProps>>>

export default defineComponent({
  name: 'OQuerytableColumnDiy',
  inheritAttrs: false,
  props: querytableColumnDiyProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
